import React, {Component} from 'react';
import { DragLayer } from 'react-dnd'
import { ModuleTypes } from '../../constants/sidebar/DragAndDropTypes';
@DragLayer(monitor => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
}))

class DragModule extends Component {
    constructor(props) {
        super(props);
    }

    makeStyle() {
        const { initialOffset, currentOffset } = this.props
        if (!initialOffset || !currentOffset) {
            return null
        }

        return {
            display: 'block',
            position: 'fixed',
            pointerEvents: 'none',
            zIndex: 10000,
            top: currentOffset.y - 25 + "px",
            left: currentOffset.x - 25 + "px"
        }
    }

    render() {

        const { item, isDragging } = this.props;

        if (!isDragging) {
            return null
        }

        return (
            <div className="item_drag" style={this.makeStyle()}>
                <div className="item_order">
                    <div className="wrap_drag">
                        <span className="ico_blog ico_drag" />
                    </div>
                    <span className="txt_name">
                        { item.module.type===ModuleTypes.PLUGIN ? <span className="txt_plugin">[플러그인] </span>:''}
                        { item.module.type===ModuleTypes.AD ? <span className="txt_plugin">[광고] </span>:''}
                        {item.module.title}
                    </span>
                </div>
            </div>
        );
    }
}

export default DragModule;
